import {Container, Text, Wrap, EmailLink} from "./styled";
import { useFooter } from "../../../queries";

export const Copyrights = () => {
    const {data: footer} = useFooter();
        const data = footer?.[0] || {};
    return (
        <Container>
            <Wrap>
                <Text>
                    {data?.rights || ''}
                    {/*{data?.email && (*/}
                    {/*    <> | <EmailLink href={data.email}>Contact</EmailLink></>*/}
                    {/*)}*/}
                </Text>
            </Wrap>
        </Container>
    )
}
